import { render, staticRenderFns } from "./AfpList.vue?vue&type=template&id=1c9af5e0&"
import script from "./AfpList.vue?vue&type=script&lang=js&"
export * from "./AfpList.vue?vue&type=script&lang=js&"
import style0 from "./AfpList.vue?vue&type=style&index=0&id=1c9af5e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports